import ActionMenu from "@common/dropdowns/actionMenu"
import { RowActions } from "@common/table/types"
import { Action } from "@common/types"
import { Row } from "@tanstack/react-table"
import React from "react"

const ActionMenuButton = ({
  actions,
  onRowActionClick,
  row,
}: {
  row: Row<any>
} & RowActions) => {
  const handleClick = (action: Action) => {
    onRowActionClick?.(row.original, action)
  }

  return (
    <div className="text-center relative float-right ">
      <ActionMenu
        actions={actions}
        onActionClick={handleClick}
        showIconMenuOnHover
      />
    </div>
  )
}

export default ActionMenuButton
